import { formatDate, generateRandomUniqueId } from "@/helpers";

const localize = payload => ({
    _id: generateRandomUniqueId(),
    changeSecretaryFormId: payload.id,
    companyProcessId: payload.company_process.id,

    userId: payload.company_secretary.user?.id,
    idType: payload.company_secretary.user.user_info?.id_type
        ? {
            id: payload.company_secretary.user.user_info.id_type?.id,
            name: payload.company_secretary.user.user_info.id_type?.name,
        }
        : undefined,
    nric: payload.company_secretary.user?.user_info?.NRIC,
    name: payload.company_secretary.user?.user_info?.legal_name ?? payload.company_secretary.user?.name,
    dob: formatDate(payload.company_secretary.user?.user_info?.DOB),
    dateOfExpiry: formatDate(payload.company_secretary.user?.user_info?.date_of_expiry),
    nationality: {
        text: payload.company_secretary.user?.user_info?.nationality?.name,
        value: payload.company_secretary.user?.user_info?.nationality?.id
    },
    email: payload.company_secretary.user?.email,
    contactNumber: payload.company_secretary.user?.user_info?.contact_number,
    address: payload.company_secretary.user?.user_info?.address,

    isAppointment: payload.is_appointment,

    appointmentDate: formatDate(payload.company_secretary.appointment_date),
    cessationDate: payload.date_of_resignation ? formatDate(payload.date_of_resignation) : undefined,

    secretary: payload.company_secretary,
});

export default localize;